import React, { PropTypes } from 'react';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import CircularProgress from 'material-ui/CircularProgress';
import _l from 'lodash';

import AccountSmsTransactionListRow from './AccountSmsTransactionListRow';

const styles = {
  table: {
    column: {
      date: {
        width: 10,
      },
      count: {
        width: 10,
      },
      cost: {
        width: 10,
      },
    },
  }
};

const AccountSmsTransactionsList = ({ accountSmsTransactions, isLoadingForSmsFetch }) => {

  return (
    <Table
      selectable={false}>
      <TableHeader
        adjustForCheckbox={false}
        displaySelectAll={false}>
        <TableRow>
          <TableHeaderColumn style={styles.table.column.date}>時間</TableHeaderColumn>
          <TableHeaderColumn style={styles.table.column.count}>次數</TableHeaderColumn>
          <TableHeaderColumn style={styles.table.column.cost}>成本</TableHeaderColumn>
        </TableRow>
      </TableHeader>
      <TableBody
        displayRowCheckbox={false}
        style={{
          textAlign: 'center',
        }}>
        {
          isLoadingForSmsFetch ?
            <TableRow>
              <TableRowColumn>
                <div style={{
                  textAlign: 'center',
                }}>
                  <CircularProgress style={{
                    marginTop: 10,
                  }} />
                </div>
              </TableRowColumn>
            </TableRow>
            :
            _l.map(accountSmsTransactions, (accountSmsTransaction, index) =>
              <AccountSmsTransactionListRow key={index}
                                            accountSmsTransaction={accountSmsTransaction}
                                            rowStyles={styles.table} />
            )
        }
      </TableBody>
    </Table>
  );
};

AccountSmsTransactionsList.propTypes = {
  accountSmsTransactions: PropTypes.array.isRequired,
  isLoadingForSmsFetch: PropTypes.bool,
};

export default AccountSmsTransactionsList;


// WEBPACK FOOTER //
// client/adminPanel/panel/accounts/AccountSmsTransactionsList.js